/**
 * @generated SignedSource<<9f33e62d7507acbe6c004adf1408548f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useBookingPaymentCards_session$data = {
  readonly currentClientProfile: {
    readonly member: {
      readonly squareCards?: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly default: boolean;
            readonly enabled: boolean;
            readonly expMonth: number;
            readonly expYear: number;
            readonly id: string;
            readonly " $fragmentSpreads": FragmentRefs<"SquareCardFragment">;
          } | null | undefined;
        } | null | undefined> | null | undefined;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly user: {
    readonly squareCards?: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly default: boolean;
          readonly enabled: boolean;
          readonly expMonth: number;
          readonly expYear: number;
          readonly id: string;
          readonly " $fragmentSpreads": FragmentRefs<"SquareCardFragment">;
        } | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "useBookingPaymentCards_session";
};
export type useBookingPaymentCards_session$key = {
  readonly " $data"?: useBookingPaymentCards_session$data;
  readonly " $fragmentSpreads": FragmentRefs<"useBookingPaymentCards_session">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "enabled",
        "value": true
      },
      {
        "kind": "Variable",
        "name": "validOnDate",
        "variableName": "bookingDate"
      }
    ],
    "concreteType": "SquareCardOnFileConnection",
    "kind": "LinkedField",
    "name": "squareCards",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "SquareCardOnFileEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "SquareCardOnFile",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "enabled",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "default",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "expMonth",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "expYear",
                "storageKey": null
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "SquareCardFragment"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "bookingDate"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "useBookingPaymentCards_session",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": (v0/*: any*/),
          "type": "MemberUser",
          "abstractKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "currentClientProfile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "member",
          "plural": false,
          "selections": [
            {
              "kind": "InlineFragment",
              "selections": (v0/*: any*/),
              "type": "Customer",
              "abstractKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Session",
  "abstractKey": null
};
})();

(node as any).hash = "a639a897472b6396fe766e0577154b14";

export default node;
